import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronArrowDiagonalUpRightFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M8.514 8.12c-.712-.462-1.45-1.038-2.229-1.719L7.986 4.7c.664.573 1.269 1.04 1.835 1.407 1.197.777 2.132 1.05 3.01.996.9-.055 1.93-.465 3.286-1.434.63-.45 1.308-1.004 2.055-1.669L20 5.828a25 25 0 0 0-1.669 2.055c-.97 1.357-1.379 2.386-1.434 3.286-.054.878.22 1.813.996 3.01.367.566.834 1.171 1.407 1.835l-1.701 1.7c-.68-.778-1.257-1.516-1.72-2.228-.91-1.405-1.431-2.793-1.386-4.282L5.697 20 4 18.303l8.796-8.796c-1.49.045-2.877-.475-4.282-1.387"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ChevronArrowDiagonalUpRightFilledSize24Glyph.displayName = 'ChevronArrowDiagonalUpRightFilledSize24Glyph';
